import emailjs from '@emailjs/browser';

    interface EmailParams {
      [key: string]: unknown;
      from_name: string,
      from_parent_name:string,
      from_email: string,
      phone: string,
      grade:string
      // Add any other dynamic fields your EmailJS template expects
    }

    const SERVICE_ID = "service_cqllldp"
    //const TEMPLATE_ID = "template_nb9wyzn"
    const PUBLIC_KEY = "yKiSUQW6BpiE2xnVG"

    if (!SERVICE_ID ||  !PUBLIC_KEY) {
      console.error("EmailJS environment variables are not set.");
      // Handle error or throw an exception as appropriate
    }

    export const EmailService = {
      sendEmail: async (params: EmailParams, TEMPLATE_ID:string): Promise<void> => {
        try {
            console.log(params.from_email+","+params.from_parent_name+","+params.from_email+","+params.phone+","+params.grade);
          if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
            throw new Error("EmailJS credentials are not configured.");
          }
          await emailjs.send(SERVICE_ID, TEMPLATE_ID, params, PUBLIC_KEY);
          console.log('Email sent successfully!');
        } catch (error) {
          console.error('Failed to send email:', error);
          throw error; // Re-throw to allow calling component to handle
        }
      },
    };